<template>
    <section class="flex-container my-4">
        <h3>Selecione o tipo do veículo:</h3>
        <div class="flex items-center flex-wrap gap-2">
            <div v-for="veiculo in tiposVeiculos" :key="veiculo.chave" :id="veiculo.chave" class="botao"
                :class="(veiculo.chave === tipoVeiculoSelecionado && 'botao-selecionado')"
                @click="selecionarTipoVeiculo(veiculo)">
                <img class="w-12" :src="veiculo.imagem"
                    :alt="`Desenho de um veículo do tipo ${veiculo.chave}`" />
                    <span class="text-xs">{{ veiculo.descricao }}</span>
            </div>
        </div>
    </section>
</template>

<script>
import { computed, defineComponent, ref } from 'vue';
import { useStore } from '@/store';
import Actions from '@/store/Actions'
import TiposVeiculosConstant from '@/constants/TiposVeiculosConstant';

export default defineComponent({
    name: 'TipoVeiculo',
    emits: ['aoSelecionarTipo'],
    methods: {
        selecionarTipoVeiculo(tipoVeiculo) {
            this.tipoVeiculoSelecionado = tipoVeiculo.chave;
            this.$store.dispatch(Actions.SALVAR_TIPO_VEICULO, tipoVeiculo.chave);
            this.$emit('aoSelecionarTipo', tipoVeiculo);
        }
    },
    setup() {
        const store = useStore();
        const tipoVeiculoSelecionado = computed(() => store.state.tipoVeiculo);
        const tiposVeiculos = ref(TiposVeiculosConstant.TODOS);

        return {
            tiposVeiculos,
            tipoVeiculoSelecionado
        }
    }
});
</script>

<style scoped>
.botao {
    @apply flex flex-col items-center justify-center py-8 w-28 h-16 border border-cinza-habilitado rounded-md hover:ring-2 hover:ring-cinza-habilitado cursor-pointer;
}

.botao-selecionado {
    @apply flex items-center justify-center bg-[#E1EDFF] border-azul-info border-2 hover:ring-2 hover:ring-azul-claro cursor-pointer;
}
</style>